import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import TrackingPage from './pages/TrackingPage';
import QuotePage from './pages/QuotePage';
import CareersPage from './pages/CareersPage';
import AboutPage from './pages/AboutPage';
import ConsultingServicesPage from './pages/ConsultingServicesPage';
import RoadTransportPage from './pages/RoadTransportPage';
import ContactPage from './pages/ContactPage';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminDashboard from './pages/AdminDashboard';
import AdminSettingsPage from './pages/AdminSettingsPage';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './contexts/AuthContext';
import { QuotesProvider } from './contexts/QuotesContext';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <QuotesProvider>
        <Router>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={
              <div className="App">
                <Header />
                <HomePage />
              </div>
            } />
            <Route path="/services" element={
              <div className="App">
                <Header />
                <ServicesPage />
              </div>
            } />
            <Route path="/services/conseils" element={
              <div className="App">
                <Header />
                <ConsultingServicesPage />
              </div>
            } />
            <Route path="/services/routiers" element={
              <div className="App">
                <Header />
                <RoadTransportPage />
              </div>
            } />
            <Route path="/tracking" element={
              <div className="App">
                <Header />
                <TrackingPage />
              </div>
            } />
            <Route path="/quote" element={
              <div className="App">
                <Header />
                <QuotePage />
              </div>
            } />
            <Route path="/careers" element={
              <div className="App">
                <Header />
                <CareersPage />
              </div>
            } />
            <Route path="/about" element={
              <div className="App">
                <Header />
                <AboutPage />
              </div>
            } />
            <Route path="/contact" element={
              <div className="App">
                <Header />
                <ContactPage />
              </div>
            } />

            {/* Admin Routes */}
            <Route path="/admin" element={<Navigate to="/admin/login" replace />} />
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/admin/dashboard" element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            } />
            <Route path="/admin/settings" element={
              <ProtectedRoute>
                <AdminSettingsPage />
              </ProtectedRoute>
            } />
          </Routes>
        </Router>
      </QuotesProvider>
    </AuthProvider>
  );
}

export default App;